// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';
import consts from "@/consts.js";
import Request from './request';

async function fetch() {
    return Request('get', "api/order-cycles/");
}

async function fetchOne(id) {
    return Request('get', "api/order-cycles/" + id);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/order-cycles/", data, false, false, true);
}

async function del(id) {
    return Request('get', "api/order-cycles/delete/" + id);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/order-cycles/edit" , data);
    } else {
        return Request('post', "api/order-cycles/add" , data);
    }
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/order-cycles/for-shop-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function imports(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/order-cycles/importShopOrderCycle", data);
}

export default {
    fetch,
    fetchOne,
    fetchAllForSelect,
    del,
    save,
    exports,
    imports,
};